<template>
	<FormGroupBox :title="this.$t('bookings.clientInfo')">
		<b-form-row>
			<b-form-group class="col-6" :label="this.$t('global.firstName')">
				<b-form-input
					:disabled="!canEdit"
					type="text"
					size="sm"
					v-model="clientFirstName"
					required
				/>
			</b-form-group>
			<b-form-group class="col-6" :label="this.$t('global.lastName')">
				<b-form-input
					:disabled="!canEdit"
					type="text"
					size="sm"
					v-model="clientLastName"
					required
				/>
			</b-form-group>
		</b-form-row>
		<b-form-row>
			<b-form-group class="col-6" :label="this.$t('global.phone')">
				<b-form-input
					:disabled="!canEdit"
					type="text"
					size="sm"
					v-model="clientPhone"
					required
				/>
			</b-form-group>
			<b-form-group class="col-6" :label="this.$t('global.email')">
				<b-form-input
					:disabled="!canEdit"
					type="text"
					size="sm"
					v-model="clientEmail"
					required
				/>
			</b-form-group>
		</b-form-row>
		<b-form-row>
			<b-form-group class="col-6" :label="this.$t('users.language')">
				<b-form-select
					:disabled="!canEdit"
					size="sm"
					v-model="clientLang"
				>
					<b-form-select-option value="en"
						>Ingles</b-form-select-option
					>
					<b-form-select-option value="es"
						>Español</b-form-select-option
					>
				</b-form-select>
			</b-form-group>

			<b-form-group class="col-6" label=".">
				<b-button variant="primary" size="sm" @click="openBillingInfo = !openBillingInfo">
					<md-icon v-if="hasBillingInfo" icon="info" /> {{ this.$t('taxInformation.taxInformation') }} <md-icon :icon="openBillingInfo ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"/>
				</b-button>
			</b-form-group>
		</b-form-row>

		<b-collapse :visible="openBillingInfo">
			<hr>
			<b-form-group :label="this.$t('taxInformation.company')">
				<b-form-input
					:disabled="!canEdit"
					type="text"
					size="sm"
					v-model="clientBillingInfo.companyName"
				/>
			</b-form-group>
			<b-form-group label="RFC">
				<b-form-input
					:disabled="!canEdit"
					type="text"
					size="sm"
					v-model="clientBillingInfo.rfc"
				/>
			</b-form-group>
			<b-form-group :label="this.$t('taxInformation.address') + ' 1'">
				<b-form-input
					:disabled="!canEdit"
					type="text"
					size="sm"
					v-model="clientBillingInfo.addressLine1"
				/>
			</b-form-group>
			<b-form-group :label="this.$t('taxInformation.address') + ' 2'">
				<b-form-input
					:disabled="!canEdit"
					type="text"
					size="sm"
					v-model="clientBillingInfo.addressLine2"
				/>
			</b-form-group>
			<b-form-group :label="this.$t('taxInformation.city')">
				<b-form-input
					:disabled="!canEdit"
					type="text"
					size="sm"
					v-model="clientBillingInfo.city"
				/>
			</b-form-group>
			<b-form-row>
				<b-form-group class="col-6" :label="this.$t('taxInformation.country')">
					<b-form-input
						:disabled="!canEdit"
						type="text"
						size="sm"
						v-model="clientBillingInfo.country"
					/>
				</b-form-group>
				<b-form-group class="col-6" :label="this.$t('taxInformation.postalCode')">
					<b-form-input
						:disabled="!canEdit"
						type="text"
						size="sm"
						v-model="clientBillingInfo.postalCode"
					/>
				</b-form-group>
			</b-form-row>
		</b-collapse>
	</FormGroupBox>
</template>

<script>
import FormGroupBox from "@/components/helpers/FormGroupBox";
import {mapFields} from '../helpers/helpers'

export default {
	components: {
		FormGroupBox
	},
	data() {
		return {
			openBillingInfo: false,
		}
	},
	props: {
		canBeUpdated: Boolean
	},
	computed: {
		//El viewModel principal esta en el modulo reservation de vuex store
		...mapFields({
			fields: ['clientFirstName', 'clientLastName', 'clientPhone', 'clientEmail', 'clientLang', 'clientBillingInfo', 'source', 'id'],
			base: 'viewModel',
			mutation: 'SET_UPDATE_MODEL',
			module: 'reservation'
		}),
		hasBillingInfo(){
			return this.clientBillingInfo.companyName || this.clientBillingInfo.rfc
		},
		canEdit () {
			return this.source === 'scadmin' || this.id === -1
		}
	},
	mounted() {
		
	}
};
</script>
